<script>
import api from '@/command/api'
import DetailFormGroup from '../../../components/DetailFormGroup'
import { getAction } from '@/command/netTool'

export default {
  name: 'applicationDetail',
  data() {
    return {
      ...api.command.getState(),
      detail: {},
      sysCodeArr: []
    }
  },
  mounted() {
    getAction('/api/app/querySysList').then(res => {
      if (res.data instanceof Array) {
        this.sysCodeArr = res.data.map(e => {
          return {
            name: e.desc,
            value: e.code
          }
        })
      }
    })
    const { id } = this.$route.query
    id &&
      api.command.getDetail.call(this, {
        url: `/app/${id}`
      })
  },
  methods: {
    getForm1() {
      return {
        title: '应用信息',
        type: 'cardForm',
        gutter: 15,
        data: [
          {
            name: '应用名称',
            type: 'input',
            cols: 12,
            key: 'appName',
            rules: [
              {
                required: true,
                type: 'string'
              }
            ]
          },
          {
            name: '应用编码',
            type: 'input',
            cols: 12,
            key: 'appCode',
            rules: [
              {
                required: true,
                type: 'string'
              }
            ]
          },
          {
            name: '应用跳转地址',
            type: 'input',
            cols: 12,
            key: 'appUrl'
          },
          {
            name: '排序',
            type: 'inputNumber',
            cols: 12,
            key: 'sort'
          },
          //   {
          //     name: '所属系统',
          //     type: 'select',
          //     cols: 12,
          //     key: 'sysCode',
          //     typeData: this.sysCodeArr,
          //     rules: [
          //       {
          //         required: true,
          //         type: 'string'
          //       }
          //     ]
          //   },
          {
            name: '备注',
            type: 'input',
            cols: 12,
            key: 'remark'
          }
        ]
      }
    },
    getForm2() {
      return {
        type: 'cardForm',
        title: '应用图片/图标',
        data: [
          {
            name: '应用图片',
            type: 'upload',
            maxLength: 1,
            cols: 12,
            key: 'appImg'
            // rules: [
            //   {
            //     required: true,
            //     message: '请上传图片',
            //     type: 'string'
            //   }
            // ]
          },
          {
            name: '应用图标',
            type: 'upload',
            maxLength: 1,
            cols: 12,
            key: 'appIcon'
            // rules: [
            //   {
            //     required: true,
            //     message: '请上传图片',
            //     type: 'string'
            //   }
            // ]
          }
        ]
      }
    },

    getFoot() {
      const left = [
        {
          name: '提交',
          type: 'primary',
          loading: this.loading,
          sumbit: true,
          onClick: data => {
            console.log(data)
            api.command[this.detail.appId ? 'edit' : 'create']
              .call(this, {
                url: '/app',
                params: {
                  ...data
                },
                isPost: false
              })
              .then(result => {
                this.$router.push('/system/application')
              })
          }
        },
        {
          name: '取消',
          type: 'default',
          onClick: () => {
            this.$router.push('/system/application')
          }
        }
      ]

      return {
        left
      }
    }
  },
  render() {
    return <DetailFormGroup foot={this.getFoot()} form={this.detail} data={[this.getForm1(), this.getForm2()]} />
  }
}
</script>
<style lang="less" scoped>
.entityInformation-detail {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 30px;
}
</style>
